/* eslint-disable */
function checkIfInIframe() {
    try {
        // This will throw an error if we're in an iframe from a different origin (same-origin policy)
        return window.self !== window.top;
    } catch (e) {
        // If we get an error, we're definitely in an iframe from a different origin
        return true;
    }
}

function getHeadlessMode() {
    const meta = document.querySelector('meta[name="headless-dokfee-mode"]');
    if (meta) {
        const value = meta.getAttribute('content');
        return value === 'true';
    }

    // Fallback: Check if certain elements are missing from the page
    // This is a heuristic and only works if the page is fully loaded
    const hasNavigation = document.querySelector('nav') !== null;
    const hasFooter = document.querySelector('footer') !== null;

    const probablyInHeadlessMode = !hasNavigation && !hasFooter;

    return probablyInHeadlessMode;
}

function reloadWithParameter(paramName, paramValue) {
    window.Sentry.captureMessage(
        `Not in iframe but headless mode is active. reloadWithParameter ${paramName}=${paramValue}`,
        'error',
    );
    console.error('Not in iframe but headless mode is active!');
    const url = new URL(window.location.href);
    url.searchParams.set(paramName, paramValue);
    window.location.href = url.toString();
}

function checkHeadlessMode() {
    const isActuallyInIframe = checkIfInIframe();
    const isInHeadlessMode = getHeadlessMode();

    if (!isActuallyInIframe && isInHeadlessMode) {
        reloadWithParameter('clear-headless-dokfee-mode', 'true');
    }
}

document.addEventListener('DOMContentLoaded', checkHeadlessMode);
/* eslint-enable */
